import { lazyWithPreload } from '../../navigation';

export const ContentGapsScreen = lazyWithPreload(() => import('./ContentGapsScreen.lazy'));

export type { ContentGapsScreenProps } from './ContentGapsScreen.lazy';
